export const ROUTE_CONNECT_RETAIL = '/';
export const ROUTE_HOME = '/home';
export const ROUTE_CFD = '/cfd';
export const ROUTE_RECEIPT_PRINTERS = '/printers/RECEIPT';
export const ROUTE_LABEL_PRINTERS = '/printers/LABEL';
export const ROUTE_CONNECTION_PRESCAN = '/printers/:kind/:connection/prescan';
export const ROUTE_CONNECTION_SCAN = '/printers/:kind/:connection/scan';
export const ROUTE_PRINTER_HELP = '/printers/:kind/:connection/help';
export const ROUTE_PRINTER_TROUBLESHOOTING = '/printers/:kind/:connection/help/troubleshooting';
export const ROUTE_TIPPING_FLOW_INPUT = `/tipping-flow/tip-input`;
export const ROUTE_TERMINAL_PAYMENT = `/terminal-payment`;
export const ROUTE_REGISTER_CUSTOMER = `/register-customer`;
